import { UserModel } from "../../../interfaces/models/userModel";
import { Link } from "react-router-dom";
import {
    ViewListingHostInfoImageWrapper,
    ViewListingHostInfoImage,
    ViewListingHostInfoVerified,
    ViewListingHostInfoTitleWrapper,
    ViewListingHostInfoTitle,
    ViewListingHostInfoTextAvatar,
} from "../viewListingStyling";

interface ViewListingHostInfoProps {
    listingOwnerProfilePictureURL: string;
    listingOwnerData: UserModel;
}

export default function ViewListingHostInfo({ listingOwnerProfilePictureURL, listingOwnerData }: ViewListingHostInfoProps) {
    return (
        <div style={{ display: "flex", alignItems: "center", marginBottom: "24px", gap: "12px" }}>
            <Link to={`/host/profile/${listingOwnerData.id}`} style={{ textDecoration: 'none' }}>
                {listingOwnerProfilePictureURL ? (
                    <ViewListingHostInfoImageWrapper>
                        <ViewListingHostInfoImage src={listingOwnerProfilePictureURL} alt="Listing owner profile picture" />
                        <ViewListingHostInfoVerified src={"https://d292awxalydr86.cloudfront.net/Universal+icons/Vector.png"} alt="Verified tick" />
                    </ViewListingHostInfoImageWrapper>
                ) : (
                    <ViewListingHostInfoImageWrapper>
                        <ViewListingHostInfoTextAvatar>{listingOwnerData?.firstName?.[0]?.toUpperCase() || '?'}</ViewListingHostInfoTextAvatar>
                        <ViewListingHostInfoVerified src={"https://d292awxalydr86.cloudfront.net/Universal+icons/Vector.png"} alt="Verified tick" />
                    </ViewListingHostInfoImageWrapper>
                )}
            </Link>
            <ViewListingHostInfoTitleWrapper>
                <ViewListingHostInfoTitle>{listingOwnerData?.firstName || 'Host'}</ViewListingHostInfoTitle>
            </ViewListingHostInfoTitleWrapper>
        </div>
    );
}
